module.exports = function() {
    document.querySelector('.hamburger').addEventListener("click", function(){
        this.classList.toggle('is-active');

        document.querySelector('.menu-main-menu-container').classList.toggle('is-active');
    });

    window.addEventListener('scroll', function(){
        let top = this.scrollY;

        if ( top > 1 ) {
            document.querySelector('header').classList.add('showBg');
        } else {
            document.querySelector('header').classList.remove('showBg');
        }
    })

    // Hide/show header when scoll
    // Initial state 
    var scrollPos = 0,
        timer = null,
        widthWindow = window.innerWidth;
    // adding scroll event
    window.addEventListener('scroll', function(){
        // detects new state and compares it with the new one
        if ((document.body.getBoundingClientRect()).top > scrollPos) {
            document.querySelector('.header').classList.remove('is-hide');
        } else {
            document.querySelector('.header').classList.add('is-hide');
        }
        // saves the new position for iteration.
        scrollPos = (document.body.getBoundingClientRect()).top;

        if( widthWindow <= 1024 ) {
            if(timer !== null) {
                clearTimeout(timer);        
            }
            timer = setTimeout(function() {
                document.querySelector('.header').classList.remove('is-hide');
            }, 350);
        }

    });
};